export const solveData = {
  finance: {
    //金融保险
    banner: {
      bg:
        "https://img14.360buyimg.com/imagetools/jfs/t1/135199/12/15314/182952/5fa909f0Ed0b67ec1/cc9ffe787e0d8987.jpg",
      title: "金融保险行业解决方案",
      subtitle:
        "提高风险控制能力、创新互联网采购模式、透明采购过程、防范采购过程中的不合规问题",
    },
    industrypain: [
      {
        icon:
          "https://img12.360buyimg.com/imagetools/jfs/t1/126829/28/18063/6558/5fa90a14E05cfa171/c07e017bb6561931.png",
        desc: "财务信息难记录留痕、容篡改",
      },
      {
        icon:
          "https://img10.360buyimg.com/imagetools/jfs/t1/130620/5/15341/10017/5fa90a14E15e0b53c/beec31e3eaf74eab.png",
        desc: "价格体系不透明，采购成本难优化",
      },
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/120392/28/17995/4946/5fa90a14Eb58c2959/09365d443c883e74.png",
        desc: "大量的业务咨询需求，人力成本高",
      },
      {
        icon:
          "https://img14.360buyimg.com/imagetools/jfs/t1/128115/15/17836/5314/5fa90a14E17607e28/daaadae74756a131.png",
        desc: "供应商动态信息缺失，难以进行风险监测",
      },
    ],
    solution: [
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/139304/12/13662/252/5fa8ecf7Ebb1118b2/b0c326d98e738eba.png",
        title: "采购全流程电子化",
        desc:
          "审批监管、电子签章、电子合同、电子发票、支付对账的全流通电子化服务。",
      },
      {
        icon:
          "https://img12.360buyimg.com/imagetools/jfs/t1/151805/26/5248/953/5fa8ecf7E375d8fa1/53adb76f1f1f1af4.png",
        title: "智能采购定价机制",
        desc:
          "设计科学定价机制，规范采购的合理价格区间，避免审计时的价格与履约价格存在偏差，提高金融采购的效率，让企业长期的运营决策更加科学。",
      },
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/152802/35/5260/826/5fa8ecf7Ef43f6351/fe04c44898fa70c7.png",
        title: "人工智能客服",
        desc: "对前置仓管理、智能补货、销售预测等环节进行智能化管理。",
      },
      {
        icon:
          "https://img10.360buyimg.com/imagetools/jfs/t1/120416/11/18045/626/5fa8ecf7Eef97dd42/15413e7a45418062.png",
        title: "智能供应链",
        desc:
          "享受定点送、定时送、精准达等配送服务，从而提供高效的采购供应链服务。",
      },
    ],
    coop: [
      {
        img:
          "https://img11.360buyimg.com/imagetools/jfs/t1/141960/25/13684/13181/5fa8ecf8Ea0d7fa00/93d879e8aadb87aa.png",
      },
      {
        img:
          "https://img10.360buyimg.com/imagetools/jfs/t1/130180/4/15236/14285/5fa8ecf8E50248bd5/e05c1b7e5d00834a.png",
      },
      {
        img:
          "https://img12.360buyimg.com/imagetools/jfs/t1/146722/21/13662/18288/5fa8ecf8E0a3198f2/bd54b035f364eb75.png",
      },
      {
        img:
          "https://img12.360buyimg.com/imagetools/jfs/t1/133880/19/15311/17460/5fa8ecf9E110c1cb4/f086dc1944019e06.png",
      },
      {
        img:
          "https://img14.360buyimg.com/imagetools/jfs/t1/141718/34/13814/47034/5fa8ecf8E96c5ddb6/41f6e7ef4ac980a1.png",
      },
      {
        img:
          "https://img13.360buyimg.com/imagetools/jfs/t1/127242/18/17986/26358/5fa8ecf8Eda32021b/6fb7f489f02a6cb0.png",
      },
      {
        img:
          "https://img13.360buyimg.com/imagetools/jfs/t1/132872/11/15272/18002/5fa8ecf8E8850bc08/9818ecf0422fc7f0.png",
      },
      {
        img:
          "https://img12.360buyimg.com/imagetools/jfs/t1/154952/9/5204/20243/5fa8ecf8E034f5799/4a5de4eb3ec3eede.png",
      },
    ],
  },
  manufacture: {
    //制造
    banner: {
      bg:
        "https://img14.360buyimg.com/imagetools/jfs/t1/121510/16/17899/296658/5fa909f1E7e3accab/7ee77f1da8082020.jpg",
      title: "制造业行业解决方案",
      subtitle:
        "MRO采购、预算前置、费用精细化管理，丰富了采购产品种类，降低了采购成本，实现了企业采购以及员工福利发放电商化",
    },
    industrypain: [
      {
        icon:
          "https://img10.360buyimg.com/imagetools/jfs/t1/136954/2/15371/5005/5fa90a15Ee30907d7/70b56fbc11248138.png",
        desc: "采买量大 、送达地址有特殊要求",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/140473/31/13691/4022/5fa90a15Ee8480d00/9528af8b23a45ac5.png",
        desc: "商品种类少，价格体系不透明",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/144837/34/14085/8725/5fa90a15E96910596/6cb883bb2ee101af.png",
        desc: "采购周期长，人力成本高",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/151337/20/6079/6645/5fa90a15E6836a47f/207eb8cd0319c1f9.png",
        desc: "结算周期长",
      },
    ],
    solution: [
      {
        icon:
          "https://img14.360buyimg.com/imagetools/jfs/t1/139112/31/13909/606/5fa8edf9Ed17d7670/b65a8f91039ff016.png",
        title: "批量下单",
        desc:
          "一个大采购单可多地址下单履约，客户可一次审批、一次报销、一次开票申请。",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/125263/26/18178/263/5fa8edf9E6453af2e/0a6e26fe710ad44b.png",
        title: "丰富商品种类",
        desc: "优选上千种商品，满足不同客户需求。",
      },
      {
        icon:
          "https://img10.360buyimg.com/imagetools/jfs/t1/120416/11/18045/626/5fa8ecf7Eef97dd42/15413e7a45418062.png",
        title: "智能供应链",
        desc: "智能采购供应链能力，数字化运营，采购交期7天缩短到2天。",
      },
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/150440/36/5991/258/5fa8edf9Ef54af96d/6702427945468613.png",
        title: "智能对账结算",
        desc: "智能对账结算，将结算天数缩短50%",
      },
    ],
    coop: [
      {
        img:
          "https://img11.360buyimg.com/imagetools/jfs/t1/144370/29/13630/20510/5fa8edf9E1db2687c/5a9c979e0b0624e9.png",
      },
      {
        img:
          "https://img13.360buyimg.com/imagetools/jfs/t1/131051/33/15380/13259/5fa8edf9Ee4aa65b2/91db286280768cb8.png",
      },
      {
        img:
          "https://img11.360buyimg.com/imagetools/jfs/t1/121858/8/17951/24865/5fa8edf9E9ee2d5e3/9cdcf1e959e497d0.png",
      },
    ],
  },
  traffic: {
    //交通
    banner: {
      bg:
        "https://img10.360buyimg.com/imagetools/jfs/t1/131513/27/15391/207230/5fa909f1Ef26b3fa1/3d42ec443a0edf89.jpg",
      title: "大交通行业解决方案",
      subtitle:
        "采购透明化，集中统一管理，提供新的采购模式与渠道，提升采购和运营效率，增强客户粘性，提高员工满意度",
    },
    industrypain: [
      {
        icon:
          "https://img10.360buyimg.com/imagetools/jfs/t1/120549/33/18232/2734/5fa90a15Eac344d6d/2bb46fc9945be9d7.png",
        desc: "需求多难满足，供应商多难管理",
      },
      {
        icon:
          "https://img10.360buyimg.com/imagetools/jfs/t1/142443/10/13817/6201/5fa90a15E24fb9747/6b646d2b6b05b437.png",
        desc: "渠道多采购的随意性很大",
      },
      {
        icon:
          "https://img14.360buyimg.com/imagetools/jfs/t1/131314/32/15294/5204/5fa90a15E5fcb069b/b9fbc553210e3ce0.png",
        desc: "流程多难审批",
      },
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/127182/11/17711/7544/5fa90a15E6f4fed17/b0462924af1dee85.png",
        desc: "地域偏远、配送成本高",
      },
    ],
    solution: [
      {
        icon:
          "https://img14.360buyimg.com/imagetools/jfs/t1/121578/10/18068/354/5fa8eed5E5df8c2cd/de6ef23fc130a626.png",
        title: "采集和监控商品价格",
        desc: "节省企业采购成本，相较于传统采购渠道节支率可以大大提高。",
      },
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/139304/12/13662/252/5fa8ecf7Ebb1118b2/b0c326d98e738eba.png",
        title: "全流程电子化采购",
        desc: "规范采购效率，大大提升了财务结算效率。",
      },
      {
        icon:
          "https://img10.360buyimg.com/imagetools/jfs/t1/120416/11/18045/626/5fa8ecf7Eef97dd42/15413e7a45418062.png",
        title: "智能供应链",
        desc: "智能采购供应链能力，数字化运营，采购交期7天缩短到2天。",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/155408/1/5213/228/5fa8eed5E576fecc8/505b34c1e4bd190c.png",
        title: "京东物流能力",
        desc: "缩短商品物资配送周期，有效降低铁路企业仓储成本。",
      },
    ],
    coop: [
      {
        img:
          "https://img14.360buyimg.com/imagetools/jfs/t1/125202/21/17895/21553/5fa8eed5Eb90127a9/411172d8355c0097.png",
      },
      {
        img:
          "https://img11.360buyimg.com/imagetools/jfs/t1/146444/29/13553/34115/5fa8eed5E143c2460/8de30d6cc4713cff.png",
      },
      {
        img:
          "https://img11.360buyimg.com/imagetools/jfs/t1/130052/8/15113/21611/5fa8eed5Ebc0b5122/1d02f2cc63bef17a.png",
      },
      {
        img:
          "https://img10.360buyimg.com/imagetools/jfs/t1/120982/22/18056/24336/5fa8eed5E5485238e/f9d572eaba657af1.png",
      },
    ],
  },
  operators: {
    //运营商
    banner: {
      bg:
        "https://img11.360buyimg.com/imagetools/jfs/t1/133858/37/15246/208922/5fa909f0E9d891183/bc8e48f7392807a5.jpg",
      title: "运营商行业解决方案",
      subtitle:
        "电商化企业采购，采购要素管控，订单事中审批，全程供应链管理，总部一点结算，库存可视化管理",
    },
    industrypain: [
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/143196/10/13806/2593/5fa90a13E1d057a08/781d99fe42e1b004.png",
        desc: "物资商品品种需求多",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/144468/9/13551/6247/5fa90a13E05ba4fc7/f1baff2df951fb80.png",
        desc: "采购时效率低成本高",
      },
      {
        icon:
          "https://img12.360buyimg.com/imagetools/jfs/t1/136079/34/15262/6769/5fa90a14E5249fae9/c2e249c040818c43.png",
        desc: "采购下单付款流程繁琐",
      },
      {
        icon:
          "https://img12.360buyimg.com/imagetools/jfs/t1/129786/12/15318/3096/5fa90a14E0f9832ae/5bfb20247f728f50.png",
        desc: "员工福利个人积分消耗率低",
      },
    ],
    solution: [
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/125263/26/18178/263/5fa8edf9E6453af2e/0a6e26fe710ad44b.png",
        title: "丰富的商品，定制商品池",
        desc: "丰富的自营商品，企业专属运营维护商品池内容。",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/155408/1/5213/228/5fa8eed5E576fecc8/505b34c1e4bd190c.png",
        title: "京东供应链能力",
        desc: "提供品牌、商品、物流、技术等综合能力，提高采购效率。",
      },
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/130308/32/15431/235/5fa8efb4Ec72be6d5/09e313dc48ae94fd.png",
        title: "电子发票智能结算",
        desc: "交易结算支付风险智能控制，全面提升交易处理能力。",
      },
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/129767/9/15075/221/5fa8efb4Efd346656/a7c8b6371ecd750e.png",
        title: "混合支付能力",
        desc:
          "针对客户B2B2C员工福利、市场营销等积分兑换场景，减少积分场景小额积分的沉淀和失效。",
      },
    ],
    coop: [
      {
        img:
          "https://img11.360buyimg.com/imagetools/jfs/t1/121066/25/17915/12727/5fa8efb4Eb5f74df0/af1a089b221285d0.png",
      },
      {
        img:
          "https://img12.360buyimg.com/imagetools/jfs/t1/152456/28/5189/28494/5fa8efb4E69dccb29/ee590b8b24c49566.png",
      },
      {
        img:
          "https://img14.360buyimg.com/imagetools/jfs/t1/132898/12/15341/25439/5fa8efb4E7c3c2b27/90f71c536edcefad.png",
      },
    ],
  },
  energy: {
    //能源
    banner: {
      bg:
        "https://img11.360buyimg.com/imagetools/jfs/t1/147323/13/13671/275117/5fa909f1E3bca2e76/48947d8cedab4ff8.jpg",
      title: "能源行业解决方案",
      subtitle:
        "丰富营销手段、提高用户粘性、有利资金冗余、提供大数据分析、实现二次变现",
    },
    industrypain: [
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/152694/3/5215/8171/5fa90a15Ec1e0ea68/21e1b5c9aa5db140.png",
        desc: "物资供应和采购计划不到位",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/126774/16/17983/2760/5fa90a15Eed5224d6/b62e18edcecda9de.png",
        desc: "采购工作缺少监督制衡机制",
      },
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/130848/16/15193/3070/5fa90a15E6c883582/672278a062e4f5da.png",
        desc: "物资消耗定额管理、原始记录不健全",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/143196/10/13806/2593/5fa90a13E1d057a08/781d99fe42e1b004.png",
        desc: "采购的物资种类繁多",
      },
    ],
    solution: [
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/126476/14/18001/259/5fa8f08eEb95d6597/42c6d7e55086f0e8.png",
        title: "电子合同管理采购计划",
        desc:
          "能够按照中标信息及自定义的合同模板，生成电子合同，进行汇总、保存和管理。",
      },
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/139304/12/13662/252/5fa8ecf7Ebb1118b2/b0c326d98e738eba.png",
        title: "采购全流程线上化",
        desc: "公平、公正、公开的进行采购，规范采购行为，堵塞漏洞。",
      },
      {
        icon:
          "https://img12.360buyimg.com/imagetools/jfs/t1/147221/38/13910/215/5fa8f08eEb1b3811a/b096f77741b8c8a1.png",
        title: "大数据支持数据沉淀",
        desc: "记录大量历史信息，提供数据将进行分析。",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/125263/26/18178/263/5fa8edf9E6453af2e/0a6e26fe710ad44b.png",
        title: "丰富的商品，定制商品池",
        desc: "通过数字化运营提升财务、商品、物流等模块的用户体验。",
      },
    ],
    coop: [
      {
        img:
          "https://img12.360buyimg.com/imagetools/jfs/t1/132284/25/15332/30873/5fa8f08eEcf87655b/e7b11befef4e45cc.png",
      },
      {
        img:
          "https://img11.360buyimg.com/imagetools/jfs/t1/121285/15/17977/40993/5fa8f08fE2de66ebd/138cd0c2ce1f6c55.png",
      },
      {
        img:
          "https://img12.360buyimg.com/imagetools/jfs/t1/145746/31/13793/11421/5fa8f08fEd4005364/21e7c62e926181d9.png",
      },
      {
        img:
          "https://img11.360buyimg.com/imagetools/jfs/t1/137019/2/15281/48441/5fa8f08fE06c52a5c/ab7ccc3a65ecdcd0.png",
      },
      {
        img:
          "https://img12.360buyimg.com/imagetools/jfs/t1/139861/3/13716/21744/5fa8f08eEd3d2c29e/ca64b5b24afc459b.png",
      },
      {
        img:
          "https://img11.360buyimg.com/imagetools/jfs/t1/142485/32/13769/17882/5fa8f08eE13c74c60/61918058713ad6d6.png",
      },
      {
        img:
          "https://img11.360buyimg.com/imagetools/jfs/t1/137731/3/13819/54213/5fa8f08eE4abf4153/63f341f943f8b6ad.png",
      },
      {
        img:
          "https://img10.360buyimg.com/imagetools/jfs/t1/142042/15/13728/28125/5fa8f08fE8cf8933b/d4b3d8728420217e.png",
      },
      {
        img:
          "https://img10.360buyimg.com/imagetools/jfs/t1/125885/35/17938/13853/5fa8f08fE2be0706c/d68aa8eac958f21c.png",
      },
      {
        img:
          "https://img13.360buyimg.com/imagetools/jfs/t1/145058/16/13928/26501/5fa8f08fE39a2a250/e44d7a652070d6af.png",
      },
      {
        img:
          "https://img12.360buyimg.com/imagetools/jfs/t1/140479/28/13885/21553/5fa8f09aE79b69000/7a3f9c98b949cb33.png",
      },
      // {
      //   img: "",
      // },
    ],
  },
  internet: {
    //互联网
    banner: {
      bg:
        "https://img10.360buyimg.com/imagetools/jfs/t1/149634/28/13899/217777/5fa909f1Ed47a8308/be7f3094910d6807.jpg",
      title: "互联网行业解决方案",
      subtitle:
        "完善兑换体系，提升运营效率，丰富兑换品类，提高用户兑换体验，增强客户粘性",
    },
    industrypain: [
      {
        icon:
          "https://img12.360buyimg.com/imagetools/jfs/t1/136079/34/15262/6769/5fa90a14E5249fae9/c2e249c040818c43.png",
        desc: "采购流程模式僵化，采购审批手续繁琐",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/126774/16/17983/2760/5fa90a15Eed5224d6/b62e18edcecda9de.png",
        desc: "采购监控难以到位",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/152694/3/5215/8171/5fa90a15Ec1e0ea68/21e1b5c9aa5db140.png",
        desc: "采购缺乏计划性，采购工作比较被动",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/143196/10/13806/2593/5fa90a13E1d057a08/781d99fe42e1b004.png",
        desc: "采购场景丰富、涉及种类众多",
      },
    ],
    solution: [
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/139304/12/13662/252/5fa8ecf7Ebb1118b2/b0c326d98e738eba.png",
        title: "采购全流程电子化",
        desc:
          "采购全流程电子化，降低采购费用和采购成本，缩短采购周期，提高采购效率。",
      },
      {
        icon:
          "https://img12.360buyimg.com/imagetools/jfs/t1/151425/8/5954/382/5fa8f1bdE5a3035b2/0bbf58f66120b769.png",
        title: "强化管控、阳光采购",
        desc: "集中采购，提高采购透明度，标准化采购流程和协同 。",
      },
      {
        icon:
          "https://img13.360buyimg.com/imagetools/jfs/t1/139110/11/13778/953/5fa8f1c4Ec6e294e3/2609979c022d7c40.png",
        title: "企业专属价格，合理控制库存",
        desc: "支持设置参数检测最低库存，从而避免时常进行紧急采购情况的发生。",
      },
      {
        icon:
          "https://img11.360buyimg.com/imagetools/jfs/t1/125263/26/18178/263/5fa8edf9E6453af2e/0a6e26fe710ad44b.png",
        title: "商品种类丰富",
        desc:
          "归集客户需求，提供精准商品推荐，帮助企业实现营销活动效果最大化。",
      },
    ],
    coop: [
      {
        img:
          "https://img14.360buyimg.com/imagetools/jfs/t1/139964/40/13887/14925/5fa8f1bdEae951d43/c5bd023d9928abe9.png",
      },
      {
        img:
          "https://img10.360buyimg.com/imagetools/jfs/t1/128820/1/17956/8947/5fa8f1bdEe3190fc5/3995b024d391c999.png",
      },
      {
        img:
          "https://img10.360buyimg.com/imagetools/jfs/t1/145350/34/14076/24898/5fa8f1bdEd2e610b3/01cc4a22ef46e8ec.png",
      },
    ],
  },
};
